/* */
/**
 * Use for cases:
 * - Cancel RECURSIVE request when unmount component
 * - Get and check state component to handle in sagas
 *
 * E.g:
 * const isDidDetailMounted = yield select(state => state.stateComponent[components.did]);
 * if (isDidDetailMounted) {
 *   Your code...
 * }
 * */

import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import actions from 'redux/actions';

const { componentIsMounted, componentIsUnmounted } = actions;

export default (nameComponent) => {
  const authReducer = useSelector((state) => state.authReducer);
  const { isLogin, sessionId } = authReducer;
  const dispatch = useDispatch();

  return useEffect(() => {
    if (isLogin && sessionId) {
      dispatch(componentIsMounted(nameComponent));
    }
    return () => {
      dispatch(componentIsUnmounted(nameComponent));
    };
  }, [authReducer.isLogin, authReducer.sessionId]);
};
